'use strict';

function FormAppSubmitGroupUserService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId/users/:userId');
}

angular.module('dokiv')
  .factory('FormAppSubmitGroupUserService', ['$resource', 'config', FormAppSubmitGroupUserService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/form-app-submit-group/FormAppSubmitGroupUserService.js
// module id = 26
// module chunks = 0